var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "side" }, [
    _c("div", { staticClass: "topbar-img" }, [_vm._v("扫描下载脂玫乐app")]),
    _c("ul", [
      _c("li", { staticClass: "displayB" }, [
        _c("img", { attrs: { src: _vm.src1, alt: "", title: "" } }),
        _c("img", {
          staticClass: "displayNone",
          staticStyle: { width: "140px", height: "140px" },
          attrs: { src: _vm.src2, alt: "", title: "" }
        })
      ]),
      _c("li", { staticClass: "displayB" }, [
        _c("img", { attrs: { src: _vm.src3, alt: "", title: "" } }),
        _c("img", {
          staticClass: "displayNone",
          staticStyle: { width: "140px", height: "140px" },
          attrs: { src: _vm.src4, alt: "", title: "" }
        })
      ]),
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href:
                "https://www.toutiao.com/c/user/619748942939964/#mid=1627878775647236"
            }
          },
          [_c("img", { attrs: { src: _vm.src5, alt: "", title: "" } })]
        )
      ]),
      _c("li", [
        _c("a", { attrs: { href: "https://weibo.com/u/6259280293" } }, [
          _c("img", { attrs: { src: _vm.src6, alt: "", title: "" } })
        ])
      ]),
      _c("li", { staticClass: "displayB" }, [
        _c("img", { attrs: { src: _vm.src7, alt: "", title: "" } }),
        _c("img", {
          staticClass: "displayNone",
          staticStyle: { width: "140px", height: "140px" },
          attrs: { src: _vm.src8, alt: "", title: "" }
        })
      ]),
      _c("li", { staticClass: "gotoTop", on: { click: _vm.toTop } })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60ef2d09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60ef2d09","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/Sidebar.vue
// module id = 667
// module chunks = 25